import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import WorkspaceAppModelContext from "../../../Context/Workspace/WorkspaceAppModelContext";
import { useTranslation } from "react-i18next";

/* refactored - ali */
const OneToOne = (props) => {

	const navigate = useNavigate();
	const { mutators } = useContext(WorkspaceAppModelContext);
	const { t } = useTranslation("linked_entity/cardinality_shapes", { useSuspense: false });

	function navigateToEntity(entity) {
		if (props.isAccessedFromWorkspace) {
			mutators.setSelectedTab(0);
			mutators.setSelectedEntity(entity);
		} else {
			navigate(`/${props.orgName}/${props.projectName}/Entities/${entity.sysName}/Attributes`);
		}
	}

	return (
		<div className="selected-cardinality1">
			<div className="py-1 text-center bigger txt-link pointer">
				<u onClick={props.onClick}>
					{t("cardinality.one_to_one", { ns: "linked_entity/cardinality_shapes" })}
				</u>
			</div>
			<div className="m-0 row no-gutters" style={{ height: 40 }}>
				<div className="col-5 p-0">
					<div className="p-2 text-center rounded text-truncate btn-secondary-shape" title={props.left}>
						{props.left}
					</div>
				</div>
				<div className="col-2 p-0 d-flex align-items-center justify-content-center O2O">{/* <img src={O2O} alt="One To One"/> */}</div>
				<div className="col-5 p-0">
					<div className="p-2 text-center rounded text-truncate btn-secondary-shape" title={props.right}>
						{props.right}
					</div>
				</div>
			</div>
			<div className="mt-2 mb-2 d-block text-center">
				&nbsp;{ t("one", { ns: "linked_entity/cardinality_shapes" }) }
				<b className="cardinality-label" title={props.left}>
					&nbsp;
					{
						props.fromEntity ?
							<span className="cursor-pointer text-link" onClick={() => navigateToEntity(props.fromEntity)}>
								{props.left}
							</span>
							:
							props.left
					}
				</b>
				&nbsp;{ t("can_be_linked_to", { ns: "linked_entity/cardinality_shapes" }) } { t("one", { ns: "linked_entity/cardinality_shapes" }).toLowerCase() }
				<b className="cardinality-label" title={props.right}>
					&nbsp;
					{
						props.toEntity ?
							<span className="cursor-pointer text-link" onClick={() => navigateToEntity(props.toEntity)}>
								{props.right}
							</span>
							:
							props.right
					}
				</b>
			</div>
			<div className="mb-2 d-block text-center">
				&nbsp;{ t("one", { ns: "linked_entity/cardinality_shapes" }) }
				<b className="cardinality-label" title={props.right}>
					&nbsp;
					{
						props.toEntity ?
							<span className="cursor-pointer text-link" onClick={() => navigateToEntity(props.toEntity)}>
								{props.right}
							</span>
							:
							props.right
					}
				</b>
				&nbsp;{ t("can_be_linked_to", { ns: "linked_entity/cardinality_shapes" }) } { t("one", { ns: "linked_entity/cardinality_shapes" }).toLowerCase() }
				<b className="cardinality-label" title={props.left}>
					&nbsp;
					{
						props.fromEntity ?
							<span className="cursor-pointer text-link" onClick={() => navigateToEntity(props.fromEntity)}>
								&nbsp;{props.left}
							</span>
							:
							props.left
					}
				</b>
			</div>
			</div>
	);
};

const OneToMany = (props) => {

	const navigate = useNavigate();
	const { mutators } = useContext(WorkspaceAppModelContext);

	const { t } = useTranslation("linked_entity/cardinality_shapes", { useSuspense: false });

	function navigateToEntity(entity) {
		if (props.isAccessedFromWorkspace) {
			mutators.setSelectedTab(0);
			mutators.setSelectedEntity(entity);
		} else {
			navigate(`/${props.orgName}/${props.projectName}/Entities/${entity.sysName}/Attributes`);
		}
	}

	return (
		<div className="selected-cardinality1">
			<div className="py-1 text-center bigger txt-link pointer">
				<u onClick={props.onClick}>
					{t("cardinality.one_to_many", { ns: "linked_entity/cardinality_shapes" })}
				</u>
			</div>

			<div className="m-0 row no-gutters" style={{ height: 40 }}>
				<div className="col-5 p-0">
					<div className="p-2 text-center rounded text-truncate btn-secondary-shape" title={props.left}>
						{props.left}
					</div>
				</div>
				<div className="col-2 p-0 d-flex align-items-center justify-content-center O2M">{/* <img src={O2M} alt="One To Many"/> */}</div>
				<div className="col-5 p-0">
					<div className="p-2 text-center rounded text-truncate btn-secondary-shape" title={props.right}>
						{props.right}
					</div>
				</div>
			</div>

			<div className="mt-2 mb-2 d-block text-center">
				&nbsp;{t("one", { ns: "linked_entity/cardinality_shapes" })}
				<b className="cardinality-label" title={props.left}>
					&nbsp;
					{
						props.fromEntity ?
							<span className="text-link cursor-pointer" onClick={() => navigateToEntity(props.fromEntity)}>
								{props.left}
							</span>
							:
							props.left
					}
				</b>
				&nbsp;{t("can_be_linked_to", { ns: "linked_entity/cardinality_shapes" })} {t("many", { ns: "linked_entity/cardinality_shapes" }).toLowerCase() }
				<b className="cardinality-label" title={props.right}>
					&nbsp;
					{
						props.toEntity ?
							<span className="text-link cursor-pointer" onClick={() => navigateToEntity(props.toEntity)}>
								{props.right}
							</span>
							:
							props.right
					}
				</b>
			</div>
			<div className="mb-2 d-block text-center">
				&nbsp;{t("one", { ns: "linked_entity/cardinality_shapes" })}
				<b className="cardinality-label" title={props.right}>
					&nbsp;
					{
						props.toEntity ?
							<span className="text-link cursor-pointer" onClick={() => navigateToEntity(props.toEntity)}>
								{props.right}
							</span>
							:
							props.right
					}
				</b>
				&nbsp;{t("can_be_linked_to", { ns: "linked_entity/cardinality_shapes" })} {t("one", { ns: "linked_entity/cardinality_shapes" }).toLowerCase()}
				<b className="cardinality-label" title={props.left}>
					&nbsp;
					{
						props.fromEntity ?
							<span className="text-link cursor-pointer" onClick={() => navigateToEntity(props.fromEntity)}>
								{props.left}
							</span>
							:
							props.left
					}
				</b>
			</div>
			</div>
	);
};

const ManyToMany = (props) => {

	const navigate = useNavigate();
	const { mutators } = useContext(WorkspaceAppModelContext);

	const { t } = useTranslation("linked_entity/cardinality_shapes", { useSuspense: false });

	function navigateToEntity(entity) {
		if (mutators) {
			mutators.setSelectedTab(0);
			mutators.setSelectedEntity(entity);
		} else {
			navigate(`/${props.orgName}/${props.projectName}/Entities/${entity.sysName}/Attributes`);
		}
	}

	return (
		<div className="selected-cardinality1">
			<div className="py-1 text-center bigger txt-link pointer">
				<u onClick={props.onClick}>
					{t("cardinality.many_to_many", { ns: "linked_entity/cardinality_shapes" })}
				</u>
			</div>

			<div className="m-0 row no-gutters" style={{ height: 40 }}>
				<div className="col-5 p-0">
					<div className="p-2 text-center rounded text-truncate btn-secondary-shape" title={props.left}>
						{props.left}
					</div>
				</div>
				<div className="col-2 p-0 d-flex align-items-center justify-content-center M2M">{/* <img src={M2M} alt="Many To Many"/> */}</div>
				<div className="col-5 p-0">
					<div className="p-2 text-center rounded text-truncate btn-secondary-shape" title={props.right}>
						{props.right}
					</div>
				</div>
			</div>

			<div className="mt-2 mb-2 d-block text-center">
				&nbsp;{ t("one", { ns: "linked_entity/cardinality_shapes" }) }
				<b className="cardinality-label" title={props.left}>
					&nbsp;
					{
						props.fromEntity ?
							<span className="cursor-pointer text-link" onClick={() => navigateToEntity(props.fromEntity)}>
								{props.left}
							</span>
							:
							props.left
					}
				</b>
				&nbsp;{ t("can_be_linked_to", { ns: "linked_entity/cardinality_shapes" }) } { t("many", { ns: "linked_entity/cardinality_shapes" }).toLowerCase() }
				<b className="cardinality-label" title={props.right}>
					&nbsp;
					{
						props.toEntity ?
							<span className="cursor-pointer text-link" onClick={() => navigateToEntity(props.toEntity)}>
								{props.right}
							</span>
							:
							props.right
					}
				</b>
			</div>
			<div className="mb-2 d-block text-center">
				&nbsp;{ t("one", { ns: "linked_entity/cardinality_shapes" }) }
				<b className="cardinality-label" title={props.right}>
					&nbsp;
					{
						props.toEntity ?
							<span className="cursor-pointer text-link" onClick={() => navigateToEntity(props.toEntity)}>
								{props.right}
							</span>
							:
							props.right
					}
				</b>
				&nbsp;{ t("can_be_linked_to", { ns: "linked_entity/cardinality_shapes" }) } { t("many", { ns: "linked_entity/cardinality_shapes" }).toLowerCase() }
				<b className="cardinality-label" title={props.left}>
					&nbsp;
					{
						props.fromEntity ?
							<span className="cursor-pointer text-link" onClick={() => navigateToEntity(props.fromEntity)}>
								{props.left}
							</span>
							:
							props.left
					}
				</b>
			</div>
			</div>
	);
};

export { ManyToMany, OneToMany, OneToOne };
